/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Faq_Req_AInputs */

const en_wc_faq_req_a = /** @type {(inputs: Wc_Faq_Req_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The desktop app runs on Windows 10 and 11, current macOS on Apple silicon or Intel, most 64-bit Linux distributions and FreeBSD 14. It draws with the GPU through DirectX 12, Metal or Vulkan and falls back to software rendering on older PCs. WordCraft online needs a recent browser with WebGPU or WebGL2.`)
};

/**
* | output |
* | --- |
* | "The desktop app runs on Windows 10 and 11, current macOS on Apple silicon or Intel, most 64-bit Linux distributions and FreeBSD 14. It draws with the GPU thr..." |
*
* @param {Wc_Faq_Req_AInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_faq_req_a = /** @type {((inputs?: Wc_Faq_Req_AInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Faq_Req_AInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_faq_req_a(inputs)
});
export { wc_faq_req_a as "wc.faq.req.a" }